<template>
  <!--手机广告添加  -->
  <div class="detail">
    <div class="detail_box">
      <el-form
        :model="tailDas"
        :rules="modileRule"
        label-position="right"
        label-width="200px"
        ref="ruleForm"
        style="width: 100%; margin: 10px auto"
      >
        <el-row>
          <el-col :span="15">
            <el-form-item label="标题" prop="title" v-if="tailDas.type != 16">
              <el-input
                placeholder="请输入内容"
                v-model="tailDas.title"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="15">
            <el-form-item label="摘要">
              <el-input
                placeholder="请输入摘要"
                v-model="tailDas.zhaiyao"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="15" v-if="tailDas.type == 1">
            <el-form-item label="链接">
              <el-input
                placeholder="请输入内容"
                v-model="tailDas.linkTo"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="15" v-if="tailDas.type == 2">
            <el-form-item
              label="视频地址"
              prop="imgUrl"
              ref="appImgUrl"
              class="shadow"
            >
              <el-upload
                class="avatar-uploader"
                :action="serverUrl"
                :headers="header"
                name="img"
                :auto-upload="true"
                :show-file-list="false"
                :on-success="upSuccess"
              >
                <video
                  v-if="tailDas.linkTo"
                  :src="tailDas.linkTo"
                  class="avatar"
                  style="height: 100px"
                />

                <i
                  :class="
                    loadUpt
                      ? 'el-icon-loading'
                      : 'el-icon-plus avatar-uploader-icon'
                  "
                  style="margintop: 10px; font-size: 50px"
                  v-else
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="起始时间" prop="startDate">
              <el-date-picker
                v-model="tailDas.startDate"
                type="date"
                placeholder
                clearable
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="结束时间" prop="endDate">
              <el-date-picker
                v-model="tailDas.endDate"
                type="date"
                placeholder
                clearable
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="频道" prop="menuId">
              <el-select
                placeholder="请选择"
                v-model="tailDas.menuId"
                clearable
              >
                <el-option
                  v-for="item in menuDas"
                  :key="item.id"
                  :label="item.menuName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="是否分享 " prop="menuId" v-if="tailDas.type != 16">
              <el-select
                placeholder="请选择"
                v-model="tailDas.shareFlag"
                clearable
              >
                <el-option
                  v-for="item in homeLun"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="信息流位置" prop="menuId">
              <el-select
                placeholder="请选择"
                v-model="tailDas.location"
                clearable
              >
                <el-option
                  v-for="item in locationItem"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="app 端图片(650*330)" prop="imgUrl" v-if="tailDas.type != 16">
              <el-upload
                class="avatar-uploader"
                action="https://jsonplaceholder.typicode.com/posts/"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="appImg"
                :on-success="handleSuccess"
                :before-upload="beforeUpload"
                ref="uptImg"
              >
                <img
                  v-if="tailDas.imgUrl"
                  :src="tailDas.imgUrl"
                  class="avatar"
                  style="height: 100px"
                />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  style="margin: 70px 75px; font-size: 50px"
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="10" >
            <el-form-item
              label="pc 端图片(592*400)"
              prop="imgUrl"
              v-if="tailDas.type == 1||tailDas.type != 16"
            >
              <el-upload
                class="avatar-uploader"
                action="https://jsonplaceholder.typicode.com/posts/"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="pcImg"
                :on-success="handleSuccess"
                :before-upload="beforeUpload"
                ref="uptImg"
              >
                <img
                  v-if="tailDas.pcImgUrl"
                  :src="tailDas.pcImgUrl"
                  class="avatar"
                  style="height: 100px"
                />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  style="margin: 70px 75px; font-size: 50px"
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-button
            style="margin-left: 200px"
            type="primary"
            @click="submitAdd('ruleForm')"
            v-if="!editOpen && menuPerm('ad:update')"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import { baseURL } from "../../api/config";
export default {
  data() {
    return {
      backOpen: true, //开关
      editOpen: false, //编辑的出现
      tailDas: {}, //详情数据
      myHeaders: { token: this.$store.state.token },
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      modileRule: {
        title: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        linkTo: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        startDate: [
          {
            // type: "string",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        endDate: [
          {
            // type: "string",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        menuId: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        showPosition: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        isRecommend: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        isRotation: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        isHomeRotation: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
      },
      appUptImg: [], //app上传图片
      pcUptImg: [], //pc上传图片
      menuDas: [], //频道数据
      //   信息流展示：--下拉框
      messDas: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "不是",
        },
      ],
      locationItem: [
        {
          value: 1,
          label: "第一信息流",
        },
        {
          value: 2,
          label: "第二信息流",
        },
        {
          value: 3,
          label: "第三信息流",
        },
        {
          value: 4,
          label: "第四信息流",
        },
        {
          value: 5,
          label: "第五信息流",
        },
        {
          value: 6,
          label: "第六信息流",
        },
        {
          value: 7,
          label: "第七信息流",
        },
        {
          value: 8,
          label: "第八信息流",
        },
        {
          value: 9,
          label: "第九信息流",
        },
        {
          value: 10,
          label: "第十信息流",
        },
      ],
      //当前频道轮播:--下拉框
      viewLun: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "不是",
        },
      ],
      //   是否上首页：--下拉框
      homeIn: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "不是",
        },
      ],
      //首页轮播--下拉框：
      homeLun: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "不是",
        },
      ],
    };
  },
  props: ["props", "Detaildata"],
  methods: {
    upSuccess(file) {
      this.tailDas.linkTo = file.entity;
    },
    //转base64
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file.raw);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    //上传图片限制
    beforeUpload(file, fileList) {
      return new Promise((resolve) => {
        // 图片压缩
        let reader = new FileReader(),
          img = new Image();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          img.src = e.target.result;
        };

        img.onload = function () {
          let canvas = document.createElement("canvas");
          let context = canvas.getContext("2d");
          let width = "100";
          let height = "100";
          let originWidth = width;
          let originHeight = height;

          canvas.width = originWidth;
          canvas.height = originHeight;

          context.clearRect(0, 0, originWidth, originHeight);
          context.drawImage(img, 0, 0, originWidth, originHeight);

          canvas.toBlob(
            (blob) => {
              let imgFile = new File([blob], file.name, { type: file.type }); // 将blob对象转化为图片文件
              resolve(imgFile);
            },
            file.type,
            0.2
          ); // file压缩的图片类型
        };
      });
    },
    //上传成功：
    handleSuccess(res, file) {
      this.$refs.uptImg.clearValidate();
    },
    //app图片上传：
    appImg(file, fileList) {
      this.appUptImg = [];
      this.getBase64(file).then((resBase64) => {
        this.appUptImg.push(resBase64);
        if (this.appUptImg) {
          this.postAxios("/file/uploadBase64", {
            fileList: this.appUptImg,
          }).then((res) => {
            if (res.success == true) {
              this.$message.success("上传成功");
              this.tailDas.imgUrl = res.content[0]; //接口url参数
              this.appUptImg = [];
            } else if (res.success == false) {
              this.$message.error(res.message);
            }

            if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        }
      });
    },
    //pc图片上传：
    pcImg(file, fileList) {
      this.pcUptImg = [];
      this.getBase64(file).then((resBase64) => {
        this.pcUptImg.push(resBase64);
        if (this.pcUptImg) {
          this.postAxios("/file/uploadBase64", {
            fileList: this.pcUptImg,
          }).then((res) => {
            if (res.success == true) {
              this.$message.success("上传成功");
              this.tailDas.pcImgUrl = res.content[0]; //接口url参数
              this.pcUptImg = [];
            } else if (res.success == false) {
              this.$message.error("上传失败");
            }
            if (!res.success) {
              this.$message.error(res.message);
            }
            if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        }
      });
    },
    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
    formatDateTime(date) {
      const time = new Date(Date.parse(date));
      //   time.setTime(time.setHours(time.getHours() + 8));
      const Y = time.getFullYear() + "-";
      const M = this.addZero(time.getMonth() + 1) + "-";
      const D = this.addZero(time.getDate()) + " ";
      const h = this.addZero(time.getHours()) + ":";
      const m = this.addZero(time.getMinutes()) + ":";
      const s = this.addZero(time.getSeconds());
      // const s = this.addZero(time.getSeconds());
      return Y + M + D + h + m + s;
    },
    //添加保存成功：
    submitAdd(formName) {
      var id = this.Detaildata;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/ad/update", {
            id: id,
            title: this.tailDas.title, //标题
            linkTo: this.tailDas.linkTo, //广告跳转的链接
            startDate: this.formatDateTime(this.tailDas.startDate), //广告起始时间
            endDate: this.formatDateTime(this.tailDas.endDate), //广告结束时间
            imgUrl: this.tailDas.imgUrl, //app 端图片的路径
            pcImgUrl: this.tailDas.pcImgUrl, //pc 端图片的路径
            menuId: this.tailDas.menuId, //频道的 id
            showPosition: this.tailDas.showPosition, //是否页面显示
            isRecommend: this.tailDas.isRecommend, //是否上推荐首页
            isRotation: this.tailDas.isRotation, //是否上轮播
            isHomeRotation: this.tailDas.isHomeRotation, //是否上首页轮播
            shareFlag: this.tailDas.shareFlag, //是否分享
            zhaiyao:this.tailDas.zhaiyao,
            location:this.tailDas.location
          }).then((res) => {
            if (res.success == true) {
              this.$message.success("更新成功");
              this.$router.push({ path: "/mobileAdver" });
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            } else if (res.success == false) {
              this.$message.error(res.message);
            }
          });
        } else {
          this.$message.error("内容不能为空");
          return false;
        }
      });
    },

    //频道下拉框数据：
    getPosition() {
      this.getAxios("/menu/list").then((res) => {
        if (res.success == true) {
          this.menuDas = res.content;
          console.log(this.menuDas, " this.menuDas");
        }
        if (res.success == false) {
          this.$message.error(res.message);
        }
        if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //详情的数据
    getXiangs() {
      var id = this.Detaildata;
      this.getAxios("/ad/detail", {
        id: id,
      }).then((res) => {
        if (res.success == true) {
          this.tailDas = res.entity;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
  },
  created() {
    this.getPosition(); //频道数据
    this.getXiangs(); //详情数据
  },
  watch: {
    Detaildata(newVal, oldVal) {
      //  this.EditData = this.Detaildata;
      this.getXiangs();
    },
  },
  mounted() {},
};
</script>
<style scoped lang="less">
.detail {
  width: 100%;
  height: 100%;
  .detail_box {
    width: 95%;
    height: 100%;
    margin: 20px auto;
    /deep/ .avatar-uploader {
      width: 180px;
      height: 180px;
      border: 2px dashed #eee;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        height: 80px;
      }
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
      margin-top: 10px;
      margin-left: 10px;
    }
  }
}
</style>